import styled from 'styled-components'

import { palette } from '../../../theme/palette'

interface ConditionItemProps {
  isDisabled: boolean,
  isPassed: boolean,
  isLastMessageInCurrentFlow: boolean
  isLoadingIframeData?: boolean
}

export const ConditionCardsWrapper = styled.ul`
  background-color: ${palette.white};
  border-radius: 8px;
  border: 1px solid ${palette.lightGray};
  margin: 0;
  padding: 0;
`

export const ConditionCardTitle = styled.h2`
  margin: 0 12px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: ${palette.secondaryText};
`

export const ConditionCardContainer = styled.li`
  list-style-type: none;
  
  &:first-child ${ConditionCardTitle} {
    padding-top: 10px;
  }
  
  & ul {
    margin: 0;
    padding: 0;
  }
`

export const ConditionContainer = styled.li`
  border-bottom: 1px solid ${palette.lightGray};
  list-style-type: none;
  
  &:last-child {
    border-bottom: none;
  }
`

export const ConditionButton = styled.button.attrs<ConditionItemProps>((props) => ({
  tabIndex: props.isLoadingIframeData ? -1 : (!props.isLastMessageInCurrentFlow || props.isDisabled || props.isPassed) ? -1 : 0
}))<ConditionItemProps>`
  background-color: ${palette.transparent};
  pointer-events: ${props => (!props.isLastMessageInCurrentFlow || props.isDisabled || props.isPassed) ? 'none' : 'auto'};
  width: 100%;
  display: flex;
  align-items: center;
  border: none;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  padding: 10px 12px;
  text-align: left;
  
  &:focus-visible {
    outline: 2px solid ${palette.mainBlue};
  }
`

export const ConditionStatusIconContainer = styled.div.attrs(() => ({
  'aria-hidden': true
}))`
  height: 24px;
  margin-right: 12px;
`

export const ConditionName = styled.div<ConditionItemProps>`
  color: ${props => (!props.isLastMessageInCurrentFlow || props.isDisabled || props.isPassed) ? palette.mediumGray : palette.mainText};
  cursor: ${props => (!props.isLastMessageInCurrentFlow || props.isDisabled || props.isPassed) ? 'auto' : 'pointer'};
`
